export default __webpack_public_path__ + "static/media/roket.6494b6aa.mp3";